const debug = process.env.NODE_ENV !== 'production';
export const API_ROOT = debug ? 'http://evaluation.51zy.org/' : 'http://evaluation.51zy.org/';
export const JSON_ROOT = '/json/'
